import { Component, computed, DestroyRef, effect, ElementRef, HostListener, inject, OnDestroy, QueryList, signal, ViewChild, ViewChildren } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { CnetNotificationsBellModule } from '@cnet/ngx-ui';
import { NgxPermissionsService } from 'ngx-permissions';
import { merge, of, Subject, timer } from 'rxjs';
import { catchError, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { ANGULAR_ROUTES } from 'src/app/app-routing.module';
import { RouteAux } from 'src/app/core/models/route-aux.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { NotAnEasterEggDirective } from 'src/app/core/services/directives/easter';
import { NotificationService } from 'src/app/core/services/notification.service';
import { RouteConditionService } from 'src/app/core/services/route-condition.service';
import { StartupService } from 'src/app/core/services/startup.service';
import { LEGACY_ROUTES } from 'src/app/modules/legacy/legacy-routing/legacy-routing.module';
import { CnetDecimalPipe } from '../../pipes/decimal-pipe/decimal.pipe';
import { SharedModule } from '../../shared.module';
import { LanguageSwitcherModule } from '../language-switcher/language-switcher.module';
import { ProfileMenuCardModule } from '../profile-menu-card/profile-menu-card.module';
import { SandwitchMenuModule } from './sandwitch-menu/sandwitch-menu.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header-toolbar',
  templateUrl: './header-toolbar.component.html',
  styleUrls: ['./header-toolbar.component.scss'],
  imports: [
    SharedModule,
    CnetNotificationsBellModule,
    ProfileMenuCardModule,
    LanguageSwitcherModule,
    SandwitchMenuModule,
    NotAnEasterEggDirective,
    CommonModule
  ]
})
export class HeaderToolbarComponent implements OnDestroy {
  config = this.startupService.startupConfig;
  showLanguageOption = this.startupService.showLanguageOption();
  hasBlog = this.startupService.hasBlog



  isUserLoggedIn = this.authService.isUserLoggedIn
  userDetailsSignal = this.authService.userDetails
  userRole = this.authService.userRole



  private notificationRefresh$ = new Subject<any>();
  notificationsCheckForUpdate$ = merge(
    timer(0, 20 * 60000),
    this.notificationRefresh$
  ).pipe(
    switchMap((a) => this.isUserLoggedIn() ? this.notificationService.getNotifications(typeof a === 'object') : of([])))

  notifications$ = toObservable(this.isUserLoggedIn).pipe(switchMap((resp) => resp ? this.notificationsCheckForUpdate$ : of([])))
  noticationsSignal = toSignal(this.notifications$)




  hideLoginBtn$ = this.router.events.pipe(filter(e => e instanceof NavigationEnd || e instanceof NavigationStart), distinctUntilChanged(), map(e =>
    (e instanceof NavigationEnd || e instanceof NavigationStart) && e.url === '/auth'
  ))
  hideLoginBtn = toSignal(this.hideLoginBtn$);
  isMobile = false;



  routesHeaderBreaks = [];
  widthLinks = [];
  widthLinksMobile = [];

  legacyContextSignal = signal(LEGACY_ROUTES);
  spaContextSignal = signal(ANGULAR_ROUTES);
  legacyRoutesAllowed = computed<Array<RouteAux>>(() => {

    let legacyRoutesAllowed = []
    if (this.isUserLoggedIn() && this.userDetailsSignal()) {

      legacyRoutesAllowed = [].concat(...this.legacyContextSignal()
        .filter(legacyRoute =>
          legacyRoute.path != 'signup' && legacyRoute.children && legacyRoute.children.length
          && legacyRoute.children.filter(child => child.path && child.data && !child.data.notInHeaderMenu).every(child => this.verifyRoles(child))
        ).map(legacyRoute => legacyRoute.children.filter(
          child =>
            child.data && !child.data.notInHeaderMenu && this.verifyRoles(child)
            && this.verifyPermissionOnly(child.data.permissions?.only) && this.verifyPermissionExcept(child.data.permissions?.except)
            && this.routeConditionService.checkConditions(this.userDetailsSignal(), child.data.conditions)
        )
          .map((child, index) => new RouteAux(legacyRoute.path, child.path, child.data, `l/${legacyRoute.path}/${child.path}`, child.data?.order ? child.data?.order : index))
        )
      )
    }
    return legacyRoutesAllowed
  })
  spaRoutesAllowed = computed<Array<RouteAux>>(() => {

    let spaRoutesAllowed = []
    if (this.isUserLoggedIn()) {

      spaRoutesAllowed = [].concat(...this.spaContextSignal()
        .filter(spaRoute =>

          spaRoute.data && !spaRoute.data.headerFixedIcon && !spaRoute.data.notInHeaderMenu && this.verifyRoles(spaRoute)
          && this.verifyPermissionOnly(spaRoute.data.permissions?.only) && this.verifyPermissionExcept(spaRoute.data.permissions['except'])
          && this.routeConditionService.checkConditions(this.userDetailsSignal(), spaRoute.data['conditions'])
        )
      ).map((route, index) => new RouteAux(route.path, '', route.data, route.path, route.data?.order ? route.data?.order : index))
    }
    return spaRoutesAllowed
  })
  routesHeaderSignal = computed<Array<RouteAux>>(() => this.legacyRoutesAllowed().concat(this.spaRoutesAllowed()).filter(route => !route.data.profileMenuItens).sort((a, b) => a.order - b.order))
  routesProfileMenuSignal = computed(() => this.legacyRoutesAllowed().concat(this.spaRoutesAllowed()).filter(route =>
    route.data.profileMenuItens && !(route.path === 'update-company' && !this.startupService.allowSerproIntegration())
  ))

  hasInternshipTokenAES = toSignal(
    toObservable(this.isUserLoggedIn).pipe(
      switchMap(loggedIn => loggedIn ? this.startupService.hasInternshipTokenAES().pipe(catchError(() => of(false))) : of(false))
    )
  )
  hasEnableImportCoursesConfiguration = toSignal(
    toObservable(this.isUserLoggedIn).pipe(
      switchMap(loggedIn => loggedIn ? this.startupService.hasEnableImportCoursesConfiguration().pipe(catchError(() => of(false))) : of(false))
    )
  )


  
  canShowSettingsButton = computed(() => 
  this.isUserLoggedIn() && (
  this.permissionsService.getPermission('SettingsInsuranceAccess') ||
  this.permissionsService.getPermission('InstitutionTeamVisualize') ||
  this.permissionsService.getPermission('SettingsDocumentAccess') ||
  this.permissionsService.getPermission('SettingsPortalLayoutAccess') ||
  this.permissionsService.getPermission('SettingsUserPermission') ||
  this.permissionsService.getPermission('SettingsInternshipImportSummaryAccess') ||
  this.permissionsService.getPermission('EmailEdit') ||
  (this.permissionsService.getPermission('InternshipTokenAesAccess') && this.hasInternshipTokenAES())  ||
  (this.permissionsService.getPermission('ImportCoursesConfiguration')&& this.hasEnableImportCoursesConfiguration())
  ))

  destroyRef = inject(DestroyRef);


  @ViewChild('menu') menu;
  @ViewChild('cnetNotification') cnetNotification;

  @ViewChild('headerOptions') headerOptions;
  @ViewChildren('menuOption', { read: ElementRef }) allHeaderOptionsRef: QueryList<ElementRef>;

  @ViewChild('headerOptionsMobile') headerOptionsMobile;
  @ViewChildren('menuMobileOption', { read: ElementRef }) allMobileHeaderOptionsRef: QueryList<ElementRef>;


  constructor(
    private startupService: StartupService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private permissionsService: NgxPermissionsService,
    private routeConditionService: RouteConditionService,
    private router: Router,
    protected cnetDecimalPipe: CnetDecimalPipe

  ) {

    effect(() => {

      this.routesHeaderBreaks = [];
      this.widthLinks = [];
      this.widthLinksMobile = [];

      if (this.routesHeaderSignal()?.length) {
        this.resolveResize(window.innerWidth)
      }
    })

  }

  ngOnDestroy(): void {
    this.notificationRefresh$ && this.notificationRefresh$.unsubscribe();
  }


  verifyRoles(route): boolean {
    return !route.data.roles || route.data.roles.indexOf(this.userRole()) > -1;
  }

  /**
 * Execute the directive ngxPermissionsOnly
 * @param permission
 */
  private verifyPermissionOnly(permission: string | string[]) {
    return this.verifyHasPermitions(permission);
  }

  /**
 * Execute the directive ngxPermissionsExcept
 * @param permission
 */
  private verifyPermissionExcept(permission: string) {
    return permission ? !this.verifyHasPermitions(permission) : true;
  }

  private verifyHasPermitions(permission: string | string[]) {
    if (permission) {
      if (Array.isArray(permission)) {
        const allow = permission.some(perm => {
          return this.permissionsService.getPermission(perm);
        })
        return allow;
      } else {
        return this.permissionsService.getPermission(permission);
      }
    } else {
      // if there is no permission seted, then its alowed to everyone
      return true;
    }
  }


  getNotificationClick(e: PointerEvent) {
    this.isUserLoggedIn() && this.notificationRefresh$.next(e)
  }

  resolveParams(item) {
    return { ...item.parameters.map(param => this.cnetDecimalPipe.transform(param, '1.0')) }
  }

  openLink(url) {
    if (url) {
      window.open(url, '_self');
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resolveResize(event.target.innerWidth);
  }

  resolveResize(innerWidth) {
    if (innerWidth <= 992) {
      this.isMobile = true;
      this.updateLinksHeaderMobile();
    } else {
      this.isMobile = false;
      this.updateLinksHeader();
    }

  }

  updateLinksHeader() {
    setTimeout(() => {

      // espaco disponivel e a largura do headerOptions - o tamanho do btn de barras, q e 54px (mesmo se não for necessário, tenho q levar em consideracao)
      const availableSpace = this.headerOptions?.nativeElement?.offsetWidth ? this.headerOptions.nativeElement.offsetWidth - 54 : 0;

      if (this.headerOptions && availableSpace > 0) {
        if (!(this.widthLinks && this.widthLinks.length)) {
          this.allHeaderOptionsRef.map((a, index) => {

            if (this.widthLinks.length === 0) {
              this.widthLinks.push(a.nativeElement.offsetWidth);
            } else {
              this.widthLinks.push(a.nativeElement.offsetWidth + this.widthLinks[index - 1])
            }
            if (this.widthLinks[index] > availableSpace) {
              this.routesHeaderSignal()[index].visible = false;
              this.routesHeaderBreaks.push(this.routesHeaderSignal()[index]);
            }
          });

        } else {

          this.routesHeaderBreaks = [];
          this.widthLinks.map((val, index) => {
            if (availableSpace < val) {
              this.routesHeaderSignal()[index].visible = false;
              this.routesHeaderBreaks.push(this.routesHeaderSignal()[index]);
            } else {
              if (this.routesHeaderSignal() && this.routesHeaderSignal().length) {
                this.routesHeaderSignal()[index].visible = true;
              }

            }
          })

        }
      }
    }, 0);
  }

  updateLinksHeaderMobile() {
    setTimeout(() => {
      // espaco disponivel e a largura do headerOptions - o tamanho do btn de barras, q e 54px (mesmo se não for necessário, tenho q levar em consideracao)
      if (this.headerOptionsMobile) {
        const availableSpace = this.headerOptionsMobile.nativeElement.offsetWidth - 54;
        if (this.headerOptionsMobile && availableSpace > 0) {
          // const widths = this._allOptionsRef.map(a => a._getHostElement().offsetWidth)
          if (!(this.widthLinksMobile && this.widthLinksMobile.length)) {
            this.allMobileHeaderOptionsRef.map((a, index) => {

              if (this.widthLinksMobile.length === 0) {
                this.widthLinksMobile.push(a.nativeElement.offsetWidth);
              } else {
                this.widthLinksMobile.push(a.nativeElement.offsetWidth + this.widthLinksMobile[index - 1])
              }

              if (this.widthLinksMobile[index] > availableSpace) {

                this.routesHeaderSignal()[index].visible = false;
                this.routesHeaderBreaks.push(this.routesHeaderSignal()[index]);

              }

            });

          } else {

            this.routesHeaderBreaks = [];
            this.widthLinksMobile.map((val, index) => {
              if (availableSpace < val) {
                this.routesHeaderSignal()[index].visible = false;
                this.routesHeaderBreaks.push(this.routesHeaderSignal()[index]);
              } else {
                this.routesHeaderSignal()[index].visible = true;

              }
            })

          }
        }
      }
    }, 0);
  }
}
